// components/Footer.js
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <CompanyInfo>
          <CompanyName>VOLTAUTO SARL</CompanyName>
          <Address>
            rue de la vallée<br />
            51 1000 bruxelles<br />
            Belgique
          </Address>
        </CompanyInfo>

        <FooterLinks>
          <LinksColumn>
            <ColumnTitle>VOLTAUTO</ColumnTitle>
            <StyledLink to="/projets">Études de cas</StyledLink>
            <StyledLink to="/apropos">À propos</StyledLink>
            <StyledLink to="/services">Services</StyledLink>
            <StyledLink to="/contact">Contact</StyledLink>
          </LinksColumn>

          <LinksColumn>
            <ColumnTitle>SERVICES</ColumnTitle>
            <StyledLink to="/services">Stratégie & Concept</StyledLink>
            <StyledLink to="/projets">Design industriel</StyledLink>
            <StyledLink to="/apropos">Ingénierie</StyledLink>
            <StyledLink >Plateformes</StyledLink>
          </LinksColumn>

          <LinksColumn>
            <ColumnTitle>TERMS</ColumnTitle>
            <StyledLink to="/terms">Terms & Conditions</StyledLink>
            <StyledLink to="/privacy">Privacy Policy</StyledLink>
          </LinksColumn>
        </FooterLinks>
      </FooterContent>

      <Copyright>
        Copyright © {new Date().getFullYear()} Voltauto Sarl - All Rights Reserved
      </Copyright>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: #2A2A2F;
  color: #fff;
  padding: 4rem 2rem 1rem;
  width: 100%;
 z-index: 1001;
  @media (max-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
`;

const FooterContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 2rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 3rem;
  }
`;

const CompanyInfo = styled.div`
  flex: 1;
  max-width: 300px;

  @media (max-width: 1024px) {
    max-width: 100%;
  }
`;

const CompanyName = styled.h3`
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 1rem;
  color: #888;
`;

const Address = styled.p`
  font-size: 0.9rem;
  line-height: 1.6;
  color: #888;
`;

const FooterLinks = styled.div`
  flex: 2;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const LinksColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

const ColumnTitle = styled.h3`
  font-size: 0.9rem;
  font-weight: 500;
  color: #888;
  margin-bottom: 0.5rem;
`;

const StyledLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;

  &:hover {
    color: #888;
  }
`;

const Copyright = styled.div`
  margin-top: 4rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: left;
  font-size: 0.8rem;
  color: #888;

  @media (max-width: 768px) {
    margin-top: 2rem;
  }
`;

export default Footer;